<template>
    <div class="home">
        <h1 style="margin-top: 10px;;">永劫无间在线估值</h1>
		<div style="width: 1000px;color: #fff;text-align: left;margin: 10px auto;display: flex;align-items: center;flex-wrap: wrap;">
			<div v-for="(item,idx) in List" :key="item.id" style="margin-top: 10px;">
				<div class="yingxiongs" @click="showIdx==idx?showIdx=-1:showIdx=idx">
					<div style="margin-left: 20px;text-align: right;flex: 1;" :class="{xuanzhong:showIdx==idx}">{{item.title}}</div>
					<img src="../images/close.png" style="width: 20px;height: 20px;margin-left: 5px;" v-if="showIdx==idx" >
					<img src="../images/open.png" style="width: 20px;height: 20px;margin-left: 5px;" v-else >
				</div>
				
			</div>
			
		</div>
		<div class="detail-input">
			<textarea  v-model="keywords" style="width: 99%;padding: 1%;margin: 0 auto;color: #000;" rows="5" placeholder="请输入关键字"></textarea>
		</div>
		<div class="detail-input">
			<div class="detail-input-item"><input class="input" type="text"  placeholder="请输入编号" v-model="code"></div>
			<div class="detail-input-item"><input class="input" type="number" placeholder="请输入等级" v-model="level"></div>
			<div class="detail-input-item"><input class="input" type="number" placeholder="请输入通行证等级" v-model="txz"></div>
			<div class="detail-input-item"><input class="input" type="text" placeholder="请输入段位" v-model="duanwei"></div>
			<div class="detail-input-item"><input class="input" type="number" placeholder="请输入幻丝数量" v-model="huansi"></div>
			<div class="detail-input-item"><input class="input" type="number" placeholder="请输入英雄皮肤数量" v-model="yingxiong_count"></div>
			<div class="detail-input-item"><input class="input" type="number" placeholder="请输入武器数量" v-model="wuqi_count"></div>
			<div class="detail-input-item">
				<select v-model="qf" style="width: 100;" class="input">
					<option value="">选择区服</option>
					<option value="STEAM">STEAM</option>
					<option value="网易">网易</option>
				</select>
				
			</div>
		</div>
		<div style="width: 1012px;color: #fff;text-align: left;margin:0 auto;user-select: text;" v-if="unSearchedCount>0">
			未找到：<span style="margin-right: 5px;user-select: text;" v-for="(item,key) in unSearched" :key="(key+item)">{{key}}、</span>
		</div>
		<div style="width: 1012px;color: #fff;text-align: left;margin:0 auto;" v-if="!keywords">
			<div v-for="(item,idx) in List" :key="item.id" style="margin-top: 10px;">
				<div style="display:flex;flex-wrap:wrap;border: 1px solid #666;padding: 10px;" v-show="showIdx==idx">
					<div style="margin:5px;text-align: center;width: 100px;" 
						v-for="(pifu) in item.yjwj_zt_pictures" :key="pifu.icon" 
						@click="fnSelect(pifu,item)">
						<div style="position: relative;margin: 0 auto;overflow: hidden;" :style="getStyle(item)">
							<img :src="pifu.icon" style="width: 100%;height: 100%;object-fit: cover;">
							<img src="../images/xuanzhong.png" v-if="pifu.selected" style="position: absolute;z-index: 1;width: 30px;height: 30px;right: 0;bottom: 0;">
						</div>
						<div style="margin-top: 10px;color: #Fff;">{{pifu.name}}</div>
					</div>
				</div>	
			</div>
		</div>
		
		<div style="width: 1012px;color: #fff;text-align: left;margin:0 auto;display: flex;align-items: center;flex-wrap: wrap;" v-if="keywords&&refresh">
			<div v-for="item in List" :key="item.id" style="display: flex;align-items: center;flex-wrap: wrap;">
				<div v-for="(pifu) in item.yjwj_zt_pictures" :key="pifu.icon" >
					<div style="margin:5px;text-align: center;width: 100px;margin-top: 10px;"
						v-if="checkShow(pifu.name)"
						class="show-search"
						@click="fnSelect(pifu,item)">
						<div style="position: relative;margin: 0 auto;overflow: hidden;" :style="getStyle(item)">
							<img :src="pifu.icon" style="width: 100%;height: 100%; object-fit: cover;" @load="showItem(pifu.name)">
							<img src="../images/xuanzhong.png" v-if="pifu.selected" style="position: absolute;z-index: 1;width: 30px;height: 30px;right: 0;bottom: 0;">
						</div>
						<div style="margin-top: 10px;color: #Fff;">{{pifu.name}}</div>
					</div>
				</div>
				
			</div>
		</div>
		
		<div style="position: fixed;z-index: 1;right: 0;top: 20%;">
			<div class="btn-item" @click="cancelSelect()">清除选择</div>
			<div class="btn-item" @click="allSelect()">全选</div>
			<div class="btn-item" @click="createCheck('text')">生成文字</div>
		</div>
		
		<div class="y_wk" ref="capture" :style="bodyColor">
			<div class="y_main">
				<div class="y_main_s_y_s clearfix" v-if="showShuiyin">
					<div class="y_main_s_y_s_logo fl">
						<img src="../images/logo.png">
					</div>
					<div class="y_main_s_y_s_hx fl">
						<img src="../images/h_yx.png">
					</div>
					<div class="y_main_s_y_s_hx fl">
						<img src="../images/h_yx.png">
					</div>
					<div class="y_main_s_y_s_qn fr" v-if="qq_data.qq_yjwj">
						{{qq_data.qq_yjwj}}
					</div>
				</div>
				<div class="y_main_s clearfix">
					
					<div class="y_main_s_z_ab">
						<div class="y_main_s_z_bt"><img src="../images/y_logo.png"></div>
						<div class="y_main_s_z_nr">
							<div class="y_main_s_z_nr_li">
								编号：{{code}}
							</div>
							<div class="y_main_s_z_nr_li">
								等级：{{level}}
							</div>
							<div class="y_main_s_z_nr_li">
								区服：{{qf||'未选择'}}
							</div>
					
							<div class="y_main_s_z_nr_li" v-if="yingxiong_count>0">
								英雄皮肤：{{yingxiong_count}}
							</div>
							<div class="y_main_s_z_nr_li" v-if="wuqi_count>0">
								武器皮肤：{{wuqi_count}}
							</div>
							<div class="y_main_s_z_nr_li">
								幻丝数量：{{huansi||0}}
							</div>
							<div class="y_main_s_z_nr_li">
								通行证：LV.{{txz}}
							</div>
							<div class="y_main_s_z_nr_li">
								段位：{{duanwei}}
							</div>
							
						</div>
						<!-- <img class="y_main_s_zpt" src="../images/y_pt.png"> -->
					</div>
					<div class="y_main_s_y">
						
						<div class="y_main_s_y_x clearfix" :style="backgroundStyle">
							<!-- 武器 -->
							<div class="yj_wz yj_tx" v-if="hongwu>0">
								{{hongwu}}红色神品：
								<span v-for="item in wuqis" :key="item.icon">
									<span v-if="item.pinzhi=='红'">{{item.name}}</span>
								</span>
							</div>
							<div class="yj_hj yj_tx  clearfix" v-if="wuqis.length>0">
								<draggable   v-model="wuqis" style="z-index: 1;" >
									<transition-group name="flip-list" style="display: flex;flex-wrap:wrap;justify-content: center;">
										<div class="yj_hj_li" v-for="item in wuqis" :key="item.icon">
											<img class="yj_hj_lit" :src="item.icon">
										</div>
									</transition-group>
								</draggable>
								
								
							</div>
							<div class="yj_wz yj_tx" v-if="hongying>0">
								{{hongying}}红色神品：
								<span v-for="rewu in pifus" :key="rewu.icon">
									<span v-if="rewu.pinzhi=='红'">{{rewu.name}}</span>
								</span>
							</div>
							<div class="yj_pf yj_tx clearfix" v-if="pifus.length>0">
								<draggable   v-model="pifus" style="z-index: 1;" >
									<transition-group name="flip-list" style="display: flex;flex-wrap:wrap;justify-content: center;">
										<div class="yj_pf_li fl" v-for="rewu in pifus" :key="rewu.icon">
											<img class="yj_pf_lit" :src="rewu.icon">
										</div>
									</transition-group>
								</draggable>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div style="position: fixed;top: 0;right: 0;left: 0;bottom: 0;z-index: 1000;line-height: 1;" v-if="infoText">
			<div style="position: absolute;top: 0;right: 0;left: 0;bottom: 0;z-index: 1;background: rgba(0, 0, 0, 0.5);" @click="infoText=''"></div>
			
			<div style="position: absolute;top:50%;left: 50%;z-index: 2;background: #fff;border-radius: 10px;width: 800px;transform: translate(-50%,-50%);line-height: 1;padding: 10px;">
				<textarea rows="20" style="width: 100%;height: 100%;border-radius: 10px;color: #000" v-model='infoText'></textarea>
				<div  style="position: absolute;right: 10px;top:10px;z-index: 10;color: #000;width: 20px;height: 20px;font-size: 20px;text-align: center;line-height: 20px;cursor: pointer;" @click="infoText=''">X</div>
			</div>
		</div>
		
    </div>
	
</template>

<script>
import html2canvas from "html2canvas";
import { 
	// CreateImage, GetImageList,
	GetYjwjData2 ,
} from "../server";



var browser = {
    versions: (function() {
        var u = navigator.userAgent;
        return {
            //移动终端浏览器版本信息
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf("iPad") > -1, //是否iPad
            webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf("MicroMessenger") > -1, //是否微信
            qq: u.match(/\sQQ/i) == " qq" //是否QQ
        };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
};
import { 
	getStorageSync,
	Falert
} from "../unitl/common";
import { constant } from "../unitl/constant";
import draggable from "vuedraggable";
export default {
    name: "Yjwj",
    data() {
        return {
			showCreateLoading: false,
			pubgList: [],
			List: [],
			showIdx:-1,
			code:'',
			level:'',
			txz:'',
			duanwei:'',
			huansi:'',
			pinzhis:{},
			pinzhis2:{},
			yingxiong:0,
			wuqi:0,
			hongying:0,
			hongwu:0,
			pifus:[],
			wuqis:[],
			qq_data:{},
			yingxiong_count:'',
			wuqi_count:'',
			showShuiyin:true,
			keywords:'',
			keywords_arr:[],
			searched:[],
			unSearched:{},
			unSearchedCount:0,
			searchCount:0,
			refresh:true,
			color:'',
			qf:'',
			infoText:''
        };
    },
	computed:{
		bodyColor(){
			if(this.color){
				return {background:this.color};
			}
			return{};
		},
		
		backgroundStyle(){
			var backgroundImg='';
			var backgroundRepeat='';
			var bg=require('../assets/bg4.png');
			
			if(this.showShuiyin){
				backgroundImg=`url(${bg})`;
				backgroundRepeat='repeat-y';
			}
	
			let style={
				backgroundImage:backgroundImg,
				backgroundRepeat:backgroundRepeat,
				backgroundSize:'100%'
			}
			return style;
		}
	},

		
    components: {
        draggable,
    },
    watch: {
        pageIndex(val) {
            this.loadBackgounds(val);
        },
		refresh(v){
			if(!v){
				setTimeout(()=>{
					this.refresh=true;
				},100)
			}
		},
		keywords(v){
			var obj={};
			var unSearched={};
			var unSearchedCount=0;
			var searchCount=0;
			if(v){
				var temp=v.split('、');
				for(var i in temp){
					var temp_k=temp[i].replace(/ /g,'');
					obj[temp_k]=1;
					unSearched[temp_k]=1;
					unSearchedCount+=1;
					searchCount+=1;
				}
			}
			this.unSearchedCount=unSearchedCount;
			this.keywords_obj=obj;
			this.unSearched=unSearched;
			this.refresh=false;
			this.searchCount=searchCount;
		}
    },
    methods: {
		allSelect(){
			var list = document.querySelectorAll(".show-search");
			for(var i=0;i<list.length;i++){
				list[i].click();
			}
		},
		showItem(name){
			var unSearched=this.unSearched;
			delete unSearched[name];
			this.unSearchedCount-=1;
			this.unSearched=unSearched;
		},
		
		checkShow(name){
			var flag=false;
			if(this.keywords&&name){
				
				if(this.searchCount==1){
					if(name.indexOf(this.keywords)!=-1){
						flag=true;
					}
				}else{
					if(this.keywords_obj[name]){
						flag=true;
					}
				}
				
				return flag;
			}
			return flag;
		},
		cancelSelect(){
			this.pifus=[];
			this.wuqis=[];
			this.yingxiong=0;
			this.wuqi=0;
			this.hongwu=0;
			this.hongying=0;
			this.keywords='';
			this.color='';
			this.qf='';

			var pinzhis={};
			for(var i=0;i<this.List.length;i++){
				for(var j=0;j<this.List[i].yjwj_zt_pictures.length;j++){
					this.List[i].yjwj_zt_pictures[j]['selected']=false;
					pinzhis[this.List[i].yjwj_zt_pictures[j].pinzhi]=0;
				}
			}
			this.pinzhis=pinzhis;
		},
		checkPifus(obj,type){
			if(obj.selected){
				if(type=='角色皮肤'){
					if(obj.pinzhi=='红'){
						this.pifus.unshift(obj);
						this.hongying+=1;
					}else{
						this.pifus.push(obj);
					}	
				}else{
					if(obj.pinzhi=='红'){
						this.hongwu+=1;
						this.wuqis.unshift(obj);
					}else{
						this.wuqis.push(obj);
					}	
				}
			}else{
				
				if(type=='角色皮肤'){
					for(var i=0;i<this.pifus.length;i++){
						if(this.pifus[i].icon==obj.icon){
							if(this.pifus[i].pinzhi=='红'){
								this.hongying-=1;
							}
							this.pifus.splice(i,1);
							break;
						}
					}
				}else{
					for(var j=0;j<this.wuqis.length;j++){
						if(this.wuqis[j].icon==obj.icon){
							if(this.wuqis[j].pinzhi=='红'){
								this.hongwu-=1;
							}
							this.wuqis.splice(j,1);
							
							break;
						}
					}
				}
				
			}
			
		},
		fnSelect(obj,item){
			obj.selected=!obj.selected;
			if(obj.selected){
				if(item.yjwj_zt_type=='角色皮肤'){
					this.yingxiong+=1;
					this.checkPifus(obj,'角色皮肤');
				}else{
					this.wuqi+=1;
					this.checkPifus(obj,'武器皮肤');
				}
				this.pinzhis[obj.pinzhi]+=1;
			}else{
				if(item.yjwj_zt_type=='角色皮肤'){
					this.yingxiong-=1;
					this.checkPifus(obj,'角色皮肤');
				}else{
					this.wuqi-=1;
					this.checkPifus(obj,'武器皮肤');
				}
				this.pinzhis[obj.pinzhi]-=1;
			}
		},
		getStyle(obj){
			if(obj.yjwj_zt_type=='角色皮肤'){
				return{
					width:'85px',
					height:'200px'
				}
				
			}else{
				return{
					height:'58px'
				}
			}
		},
		
		createCheck(type=''){
			if(this.showCreateLoading){
				Falert('正在生成图片，请稍后');
				return;
			}
			if(!this.code){
				Falert('请输入编号');
				return;
			}
			if(!this.level){
				Falert('请输入等级');
				return;
			}
			if(!this.txz){
				Falert('请输入通行证等级');
				return;
			}
			if(!this.duanwei){
				Falert('请输入段位');
				return;
			}
			if(this.yingxiong_count<=0){
				Falert('请输入英雄皮肤数量');
				return;
			}
			if(this.wuqi_count<=0){
				Falert('请输入武器皮肤数量');
				return;
			}
			if(!this.qf){
				Falert('请选择区服');
				return;
			}
			if(type=='text'){
				this.createText();
			}else{
				this.createImg();
			}
			
		},
		createText(){
			var text='编号:'+this.code+';等级:'+this.level+';区服:'+this.qf+';英雄皮肤:'+this.yingxiong_count+';武器皮肤:'+this.wuqi_count;
			if(this.huansi>0){
				text+=';幻丝数量:'+this.huansi;
			}
			text+=';通行证:LV'+this.txz+';段位:'+this.duanwei;
			var hongText='';
			var wuqiText='';
			if(this.wuqis.length>0){
				for(var i=0;i<this.wuqis.length;i++){
					wuqiText+=this.wuqis[i].name+'、';
					if(this.wuqis[i].pinzhi=='红'){
						hongText+=this.wuqis[i].name+'、';
					}
					
				}
			}
			var pfText='';
			if(this.pifus.length>0){
				
				for(var j=0;j<this.pifus.length;j++){
					pfText+=this.pifus[j].name+'、';
					if(this.pifus[j].pinzhi=='红'){
						hongText+=this.pifus[j].name+'、';
					}
				}
			}
			if(hongText){
				text+="\n红色皮肤："+hongText;
			}
			if(wuqiText){
				text+="\n武器："+wuqiText;
			}
			if(pfText){
				text+="\n英雄："+pfText;
			}
			
			this.infoText=text;
		},
        createImg() {
            this.showCreateLoading = true;
            let rect = this.$refs.capture.getBoundingClientRect();
            const rate = 4000 / rect.height;
            if (
                rate < 1 &&
                (browser.versions.mobile ||
                    browser.versions.ios ||
                    browser.versions.android ||
                    browser.versions.iPhone ||
                    browser.versions.iPad)
            ) {
                this.$refs.capture.style.transform = `scale(${rate})`;
                rect = this.$refs.capture.getBoundingClientRect();
            }

            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            html2canvas(this.$refs.capture, {
                imageTimeout: 1000000,
                useCORS: true,
                x: Math.round(rect.x+(browser.versions.mobile?0:this.htmlCanvasAdjustX)),
                y: Math.round(rect.y),
                scrollY: -scrollTop,
                width: Math.round(rect.width-(browser.versions.mobile?0:this.htmlCanvasAdjustWidth)),
                height: Math.round(rect.height)
            }).then(canvas => {
                // 通过a标签下载到本地
                let link = document.createElement("a");
                link.href = canvas.toDataURL("image/jpeg");
                link.setAttribute("download", Date.now() + ".jpg");
                link.style.display = "none";
                document.body.appendChild(link);
                link.click();
         
                this.showCreateLoading = false;
  
                this.$refs.capture.style.transform = `scale(1)`;
            });
           
        },
        
		init(){
			GetYjwjData2().then(ret=>{
				var userInfo=JSON.parse(getStorageSync(constant.userInfo)||'{}');
				if(userInfo&&userInfo.shuiyin){
					this.showShuiyin=false;
				}
				// console.log(ret);
				this.qq_data=ret.qq_data.data;
				var res=ret.data;
				var list=[];
				var pinzhis={};
				for(var i=0;i<res.length;i++){
					var temp=res[i];
					temp.open=false;
					for(var j=0;j<temp.yjwj_zt_pictures.length;j++){
						temp.yjwj_zt_pictures[j]['selected']=false;
						pinzhis[temp.yjwj_zt_pictures[j].pinzhi]=0;
					}
					list.push(temp);
				}
				this.pinzhis=pinzhis;
				
				this.List=list;
			})
		}
    },
    mounted() {

		this.init();
		
    }
};
</script>

<style scoped>
	.btn-item .m-colorPicker {
		width: 100%;
		height: 100%;
		display: flex !important;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.btn-item .m-colorPicker::before {
		content: "选择背景颜色";
		padding-right: 7px;
	}
body::-webkit-sxrollbar {
    display: none;
}
.yingxiongs{
	font-size: 16px;
	color: #fff;display: flex;
	align-items: center;
}
h1 {
    margin-top: 140px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 28px;
}
.detail-input{
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	width: 1012px;
	margin: 10px auto;
	justify-content: start;
	
}

.detail-input-item{
	width: 24%;
	margin-left: 0.5%;
	margin-right: 0.5%;
	margin-top: 10px;
	height: 46px;
	padding:0 5px;
	background: rgba(198, 212, 223, 1);
	position: relative;
}
.detail-input-item .input{
	height: 46px;
	width: 100%;
	background: rgba(198, 212, 223, 1);
	border: none;
	outline: none;
	color: #000;
	
}

.detail-input-item .input::placeholder {
    color: #666;
}
.tips {
    padding-left: 20px;
    margin: 19px auto 0;
    width: 70px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(65, 194, 131, 1);
    line-height: 28px;
    background: url("../assets/green.png") left center no-repeat;
}
.search-box {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 60px;
}
.search-input {
    width: 510px;
    height: 46px;
    background: rgba(198, 212, 223, 1);
    border: none;
    outline: none;
    text-indent: 20px;
}
.search-input::placeholder {
    color: #869199;
}
.search-btn {
    width: 120px;
    height: 46px;
    background: rgba(44, 82, 129, 1);
    border: none;
    outline: none;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
}
.bg-box {
    display: flex;
    height: 100px;
    margin-bottom: 30px;
    align-items: center;
    justify-content: center;
}

.bg-box img {
    height: 100%;
    cursor: pointer;
}
.how {
    padding-top: 26px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    text-decoration: underline;
    color: rgba(110, 173, 223, 1);
    line-height: 17px;
}
.show-img {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 235px;
    margin-bottom: 102px;
    overflow: hidden;
}
.show-img > li {
    margin-left: 20px;
}
.result {
    margin-top: 20px;
}
.loading-show {
    margin-top: 30px;
    color: #ffffff;
}
.loader-01 {
    border: 0.2em dotted currentcolor;
    border-radius: 50%;
    -webkit-animation: 1s loader-01 linear infinite;
    animation: 1s loader-01 linear infinite;
    font-size: 14px;
    display: inline-block;
    width: 8px;
    height: 8px;
    color: inherit;
    vertical-align: middle;
    pointer-events: none;
    margin-left: 4px;
}
.create {
    display: flex;
    margin: 0 auto;
    padding-top: 100px;
    width: 1002px;
    flex-direction: column;
}
.create-l {
    padding-bottom: 24px;
}
.btn-item {
    color: #fff;
    height: 38px;
    border-radius: 4px;
    display: flex;
    width: 130px;
    align-items: center;
    justify-content: center;
    background: rgba(44, 82, 129, 1);
    position: relative;
    margin-right: 10px;
	margin-top: 10px;
    cursor: pointer;
}
.btn-item.disable {
    background: #83b5e8;
}
.xuanzhong{
	color: red;
}
.fanzhuan{
	transform: rotateX(180deg);
	color: red;
}
.bg-2{
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 0;
	background-color: rgba(0,0,0,0);
	background-repeat: repeat-y;
	background-size: 100%;
}
.create-r {
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: left top;
    width: 1000px;
    border: 1px solid #ddd;
    overflow: hidden;
    position: relative;
    top: 0;
    display: flex;
    align-items: center;
    flex-direction: column;
}
.create-r .text-content {
    color: red;
    font-size: 24px;
}
.create-r .text-content div {
    font-size: 24px;
}
.little-icons {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.little-icons .img-box {
    width: 61px;
    height: 61px;
    background: #3a3a3a;
    margin-bottom: 2px;
    padding: 4px;
}
.little-icons img {
    width: 100%;
    height: 100%;
}
.create-l > h3 {
    color: #ffffff;
    text-align: left;
    font-size: 16px;
    margin: 15px 0;
}
.desc-input {
    border: 1px solid #d7d7d7;
    height: 36px;
    width: 324px;
    padding: 0 10px;
    font-size: 15px;
    border-radius: 4px;
    margin-top: 30px;
}
.imgblock {
    width:135px;
	height: 135px;
    cursor: move;
}
.imgblock:hover {
    box-shadow: 0px 0px 5px #2a3d50;
}
.imgblock > img {
    width: 100%;
}
.flip-list-move {
    transition: transform 0.5s;
}
.preview {
    display: flex;
    flex-wrap: wrap;
    width: 960px;
}
.create-btn {
    margin-top: 30px;
    width: 150px;
    height: 40px;
    line-height: 40px;
    border-radius: 2px;
    background: rgba(44, 82, 129, 1);
    color: #ffffff;
    font-size: 16px;
}
.uploadimg {
    background-color: #ffffff;
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
}
@keyframes loader-01 {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

* {
	font-family: "微软雅黑";
	outline: none;
	font-size: 14px;
	color: #444444;
	list-style: none;
	line-height: 26px;
}

* {
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	-webkit-tap-highlight: rgba(0, 0, 0, 0);
	-webkit-text-size-adjust: none;
}

body, dl, dd, h1, h2, h3, h4, h5, h6, from {
	margin: 0;
}

img {
	max-width: 100%;
	display: block;
}

ol, ul, li, img {
	margin: 0;
	padding: 0;
	border: 0;
	outline: 0;
	vertical-align: baseline;
}

input, img, textarea {
	border: none;
	border-radius: 0;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0);
	-webkit-tap-highlight: rgba(0, 0, 0, 0);
	-webkit-text-size-adjust: none;
}

a {
	text-decoration: none;
	blr: expression(this.onFocus=this.blur()); /* IE Opera */
	outline: none; /* FF Opera */
}

a:focus {
	-moz-outline-style: none; /* FF */
}

img, input {
	border: 0;
}

input, textarea, select {
	outline: none;
}

a div, a span {
	cursor: pointer;
}

textarea {
	resize: none;
}


*, *:before, *:after {
	box-sizing: border-box;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	-o-box-sizing: border-box;
	color: #fff;
}

html, body, ul, li, a, span, p {
	padding: 0;
	margin: 0;
	list-style: none;
	line-height: 22px;
	margin: 0px;
	padding: 0px
}

img {
	border: 0px;
}

.juzhong {
	width: 1250px;
	display: block;
	margin-left: auto;
	margin-right: auto;
}

.lfd {
	float: left;
	display: block;
}

.rfd {
	float: right;
	display: block;
}

h2, h3, h4, h5 {
	text-align: center;
}

p {
	font-family: "微软雅黑";
	line-height: 26px;
}

.gg {
	width: 1200px;
	margin-left: auto;
	margin-right: auto;
}

.clear {
	clear: both;
}

.clearfix:after {
	visibility: hidden;
	display: block;
	font-size: 0;
	content: " ";
	clear: both;
	height: 0;
}

.clearfix {
	*zoom: 1;
}

.fl {
	float: left;
}

.fr {
	float: right;
}




/* 永劫无间样式开始 */
.y_wk {
	width: 1360px;
	background: url('../images/ybg.jpg');
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center top;
	background-attachment: fixed;
	min-height: 1080px;
	margin: 20px auto;
}

.y_main {
	width: 1300px;
	margin: 0px auto;
	padding: 50px 0;
	overflow: hidden;
}
.y_main_s{
	/* display: flex; */
	position: relative;
}
.y_main_s_z {
	width: 400px;
	min-height: 1000px;
/* 	height: 100%;
	background: url('../images/y_bk.png');
	position: relative;
	background-size: 100% 100%; */
}

.y_main_s_z_ab{
	background: url('../images/y_bk.png');
	background-size: 100% 100%;
}

.y_main_s_z_bt {
	position: absolute;
	left: 50%;
	top: -10px;
	transform: translate(-50%, 0);
}

.y_main_s_z_nr {
	padding-top: 50px;
	margin-left: 80px;
	margin-right: 80px;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
}

.y_main_s_z_nr_li {
	background: url('../images/w_libg.png');
	margin-bottom: 20px;
	font-size: 26px;
	color: #fff;
	font-weight: bold;
	padding: 15px;
	line-height: 32px;
	text-align: center;
	width: 25%;
}

.y_main_s_y {
	/* width: 940px; */
	overflow: hidden;
}

.y_main_s_y_s{
	margin-bottom: 30px;
}
.y_main_s_y_s_hx {
	padding-top: 28px;
	margin-left: 50px;
	
}

.y_main_s_y_s_qn {
	background: url('../images/y_btnbg.png');
	width: 334px;
	height: 50px;
	font-size: 24px;
	line-height: 24px;
	color: #fff;
	font-weight: bold;
	text-align: center;
	padding-top: 10px;
	box-sizing: border-box;
	margin-top: 20px;
}

.y_main_s_zpt {
	position: absolute;
	bottom: -80px;
	left: 46px;
	width: 80%;
}

.yj_tx {
	background: rgba(5, 28, 47, 0.3);
	padding: 20px;
	border-radius: 16px;
}

.y_main_s_y_x {
	margin-top: 30px;
}

.yj_tx_nr_li {
	width: 120px;
	height: 120px;
	border: 1px solid #7c858e;
	border-radius: 8px;
	overflow: hidden;
	margin-right: 20px;
	margin-bottom: 20px;
}

.yj_tx_nr_lit {
	width: 120px;
	height: 120px;
	object-fit: cover;
}

.yj_hj {
	margin-top: 10px;
}

.yj_hj_li {
	width: 170px;
	height: 98px;
	border: 1px solid #7c858e;
	border-radius: 8px;
	overflow: hidden;
	margin: 5px;
}

.yj_hj_lit {
	width:100%;
	height: 100%;
	object-fit: contain;
}

.yj_wz {
	margin-top: 10px;
	font-size: 30px;
	font-weight: bold;
	color: #fff;
	line-height: 1.2;
}
.yj_wz span{
	font-size: 30px;
}
.yj_pf {
	margin-top: 10px;
}

.yj_pf_li {
	width: 120px;
	height: 240px;
	border: 1px solid #7c858e;
	border-radius: 8px;
	overflow: hidden;
	margin: 6.2px;
}

.yj_pf_lit {
	width:100%;
	height: 100%;
	object-fit: cover;
}

</style>
